module.exports = __webpack_public_path__ + "img/logo-bling.6cef7a1c.png";